module.exports = __webpack_public_path__ + "img/Togo.dcacb88c.png";